<template>
    <div class="stateInventory responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader title="State Transfers" :links="[
          { name: 'home', label: 'Home' },
          { name: 'reports', label: 'Reports' },
          { name: 'inventoryReport', label: 'Inventory' },
          {
            name: 'inventoryTransfer',
            label: 'State Transfers',
          },
        ]" @export="exportToCsv" :disableExport="!reportData" />
        <br class="no-print" />
        <ReportFilter class="no-print" :filterByTime="true" @submit-filter="performGetReport" :isLoading="isLoading"
          :percentage="percentageCompleted" />
        <div class="report-container">
          <!-- This could be a component -->
          <div class="report-body" v-if="reportData">
            <table id="table-report">
              <thead>
                <tr>
                  <th align="left">Date</th>
                  <th align="left">Manifest</th>
                  <th align="left">Employee</th>
                  <th align="left">Destination</th>
                  <th align="left">Batch #</th>
                  <th align="left">Batch Sub Lot #</th>
                  <th align="left">Product</th>
                  <th align="left">Note</th>
                  <th align="right">Quantity</th>
                </tr>
              </thead>

              <tbody>
                <tr class="report-body__row"></tr>
                <tr v-for="(record, index) in reportData.records" :key="index">
                  <td>{{ record.date }}</td>
                  <td>{{ record.manifest }}</td>
                  <td>{{ record.employee }}</td>
                  <td>{{ record.customer }}</td>
                  <td class="batch">{{ record.batchId }}</td>
                  <td class="batch">{{ record.batchIdSub }}</td>
                  <td>{{ record.product }}</td>
                  <td>{{ record.stateNotes }}</td>
                  <td align="right">
                    {{ record.quantity }}
                  </td>
                </tr>
              </tbody>
              <tr class="skip-export">
                <td colspan="100%">
                  <hr class="line1" />
                </td>
              </tr>
              <tr>
                <td colspan="8">Total</td>
                <td align="right">
                  {{ reportData.total.quantity }}
                </td>
              </tr>
              <tr class="skip-export"></tr>
              <tr class="skip-export">
                <td colspan="100%">
                  <hr class="line1" />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import PageHeader from "@/components/Header/Header.vue";
  import { mapActions, mapGetters } from "vuex";
  import ReportFilter from "@/components/ReportFilter/ReportFilter";
  import Utilities from "@/lib/Utilities";
  import ReportHelper from "@/lib/report/index.js";

  export default {
    data() {
      return {
        Utilities,
      };
    },
    components: {
      PageHeader,
      ReportFilter,
    },
    created: function () {
      this.setPageTitle("State Transfers");
    },
    computed: {
      ...mapGetters({
        isLoading: "reports/isLoading",
        getData: "reports/getData",
        percentageCompleted: 'reports/percentageCompleted'
      }),
      reportData() {
        return this.getData;
      },
    },
    methods: {
      ...mapActions({
        generateReport: "reports/generate",
        clearData: "reports/clearData",
      }),
      performGetReport(filter) {
        let reportType = "inventoryTransfer";
        this.generateReport({
          reportType,
          ...filter,
        });
      },
      exportToCsv() {
        var table = document.getElementById("table-report");
        ReportHelper.exportToExcel(table, "inventoryTransfer");
      },
    },
    beforeDestroy() {
      this.clearData()
    }
  };
  </script>

  <style lang="scss">
  @import "./_inventoryTransfer.scss";
  </style>